import { BaseModel } from "../base.model"; 

export interface UnusualMessage extends BaseModel {
  
}

export const defaultUnusualMessage: Readonly<UnusualMessage> = {};